"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFilled = exports.isDefined = exports.isPresent = void 0;
function isPresent(t) {
    return t !== undefined && t !== null;
}
exports.isPresent = isPresent;
function isDefined(t) {
    return t !== undefined;
}
exports.isDefined = isDefined;
function isFilled(t) {
    return t !== null;
}
exports.isFilled = isFilled;
//# sourceMappingURL=index.js.map